<!--
 * @Description: Copyright
 * @Author: pliybird
 * @Date: 2022-01-25 22:04:14
 * @LastEditTime: 2025-10-09 17:55:49
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
    <!-- Start Copy Right Area  -->
    <div class="copyright-area copyright-style-one">
        <div class="container">
            <div class="row align-items-center">
                <div class="offset-lg-1 col-lg-4 col-sm-12 col-12">
                    <div class="copyright-left text-center">
                        <p class="copyright-text">© {{ $t('footer.copyright') + " " + new Date().getFullYear() }}</p>
                    </div>
                </div>
                <div class="col-lg-5 col-sm-12 col-12 row">
                    <div class="copyright-right col-md-6 text-center">
                        <a class="copyright-text" href="https://beian.miit.gov.cn/" target="_blank"><img class="d-inline-block" width="20" :src="require('@/assets/images/icons/cert-beian.gif')" alt="" /><span class="ml--5">沪ICP备16032679号-1</span></a>
                    </div>
                    <div class="copyright-right col-md-6 text-center">
                        <a class="copyright-text" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011802003842" target="_blank"><img class="d-inline-block" width="20" :src="require('@/assets/images/icons/beian.png')" alt="" /><span class="ml--5">沪公网安备 31011802003842</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Copy Right Area  -->
</template>

<script>
    export default {
        name: 'Copyright'
    }
</script>